import { NavRoute } from '../shared/navigation/nav.route.interface';
import { getMainNavAdmin } from './nav-areas/admin-nav';
import { getSubNavUsers } from './nav-areas/users-nav';
import { getMainNavRealtors } from './nav-areas/realtors-nav';
import { getSubNavAppointments } from './nav-areas/appointments-nav';
import { getHelpFilesNav } from './nav-areas/help-files-nav';
import { getMainNavMyAppointments } from './nav-areas/my-appointments-nav';
import { getMainNavAllAppointments } from './nav-areas/all-appointments-nav';
import { getMainNavAllCompanies, getMainNavCompany } from './nav-areas/company-nav';
import { UserJsVm } from '../shared/generated/Admin/Models/User/JavaScript/UserJsVm';

export const getMainNavRoutes: () => NavRoute[] = function () {
    const user = getUser();
    let navRoutes: Array<NavRoute> = [];
    // Admins get All Appointments in place of My Appointments (security on each nav decides which shows)
    navRoutes.push(getMainNavAllAppointments());
    if (!user?.isRealtor) { navRoutes.push(getMainNavMyAppointments()); }
    navRoutes.push(
        getMainNavRealtors()
        , getMainNavCompany()
        , getMainNavAllCompanies()
        , getMainNavAdmin()
        , getHelpFilesNav()
        , getSubNavAppointments()
        , getSubNavUsers()
    );

	return navRoutes;
};

function getUser(): UserJsVm | null {
    const userJson: string | null = localStorage.getItem('user') === null 
        ? null 
        : localStorage.getItem('user');
    if (userJson !== null) { return JSON.parse(userJson); }
    return null;
}
